import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import TagManager from 'react-gtm-module';
import { initSentry } from '@pv/common/sentry';

import App from './App';

import './index.css';

const pvEnv = process.env.REACT_APP_PV_ENV;
if (pvEnv === 'production') {
  TagManager.initialize({
    gtmId: 'GTM-PL43NJN',
  });
}

const dsn = process.env.REACT_APP_SENTRY_DSN as string;
initSentry({ dsn });

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
